// Services
import ProductService from "@/app/services/main/product/product-service"
import BrandService from "@/app/services/main/brands/brand-service"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

// Event Bus
import EventBus from "@/app/bus/event-bus.js"

// Components
const ProductModal = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/products/containers/modals/product-item-modal/product-item-modal.vue"
	)
const StoreCreditPreview = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "store-credit-preview" */ "@/app/views/main-view/products/components/store-credit-preview/store-credit-preview.vue"
	)
const ProductItemCard = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "product-item-card" */ "@/app/views/main-view/_shared/_components/product-item-card/product-item-card.vue"
	)

export default {
	name: "ProductListContainer",
	components: {
		ProductModal,
		StoreCreditPreview,
		ProductItemCard,
	},
	mixins: [toastMessageMixins, inputTextMixins, shoppingMixins, userMixins, switchPetMixins],
	data() {
		return {
			isAPILoading: false,
			isLoadMoreLoading: false,
			productList: [],
			// product
			productName: "",
			productTypeList: [],
			isProductTypeLoading: false,
			selectedProductType: null,
			// brand
			brandList: [],
			isBrandsLoading: false,
			selectedBrand: null,
			// price
			selectedPrice: null,
			priceList: [
				{ id: false, name: "Low to High" },
				{ id: true, name: "High to Low" },
				{ id: "sale", name: "On Sale" },
			],
			// modal
			modalContent: {},
			// table
			page: 1,
			limitFilter: 6,
			increment: 6,
			showNoResult: false,
			storeCredit: 0,
			availableStoreCredit: 0,
			refreshStoreCredit: false,
			onLoad: false,
			currentPage: null
		}
	},
	watch: {
		selectedProductType(newType) {
			if (!newType) {
				this.selectedBrand = null
				return
			}

			// clear any data it has when product List is refreshed
			this.brandList = []
			newType = newType.name ? newType.name : newType

			// // set the selected query to router params
			// if (this.$route.query) {
			// 	// only change query if they're not the same and has existing to avoid route redundancy
			// 	if (this.$route.query.type !== newType) {
			// 		// set the selected query to router params
			// 		this.$router.push({ query: { type: newType } })
			// 	}
			// } else {
			// 	this.$router.push({ query: { type: newType } })
			// }
			
			this.getBrandList(newType.toLowerCase())
			if(newType !== this.$route.query.type){
				  // Only update the URL with the new 'type' and remove other query params
				  const currentPath = this.$route.path;
				  const updatedQuery = { type: newType };
		  
				  // Update the URL with only the 'type' parameter
				  this.$router.push({ path: currentPath, query: updatedQuery }).catch((err) => {
					  // Optionally handle the NavigationDuplicated error
					  if (err.name !== 'NavigationDuplicated') {
						  console.error(err);
					  }
				  });
				this.getProductList(false, true, false)
			}
			this.updateUrlParam('type', newType);
		},
		selectedBrand(newBrand) {
			if (newBrand) {
				newBrand = newBrand.name ? newBrand.name : newBrand
			}
			if(!this.onLoad){
				this.getProductList(false, true, false)
			}
			this.updateUrlParam('brand', newBrand);
		},
		productName(value) {
			this.delayTyping(() => {
				this.updateUrlParam('productName', value);
				if(!this.onLoad){
					this.getProductList(false, true, false)
				}
			})
		},
		selectedPrice(newValue) {
			if (newValue) {
				newValue = newValue.name ? newValue.name : newValue
			}

			// Update the URL parameter with the final value
			this.updateUrlParam('price', newValue);

			// Call to get product list with updated parameters
			if(!this.onLoad){
				this.getProductList(false, true, true);
			}
		},
	},
	mounted() {
		this.refreshActivePetData()
	},
	created() {
		if (window.location.pathname) {
			this.currentPage = window.location.pathname.substring(1);
		}
		
		// Initialize the page based on URL or default to 1 if not provided
		this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
		
		this.setPendingOrderCount(this.getActivePet.id)
	},
	methods: {
		// Helper method to update the query parameter in the URL
		updateUrlParam(param, value) {
			// Get the current route's query parameters
			const currentQuery = { ...this.$route.query };
		
			// Update or add the new parameter value
			if (value) {
			  currentQuery[param] = value;
			} else {
			  // If the value is empty, remove the parameter
			  delete currentQuery[param];
			}
		
			// Check if the new query is different from the current query
			const currentPath = this.$route.path;
			const newQuery = currentQuery;
		
			// Only navigate if the new query is different from the current one
			if (this.isDifferentQuery(newQuery)) {
			  this.$router.push({
				path: currentPath,
				query: newQuery,
			  }).catch((err) => {
				// Optionally handle the NavigationDuplicated error
			  });
			}
		  },
		
		  // Helper method to check if the query is different
		  isDifferentQuery(newQuery) {
			// Compare the current query parameters with the new ones
			const currentQuery = this.$route.query;
			return JSON.stringify(currentQuery) !== JSON.stringify(newQuery);
		  },
		emitStoreCreditPreviewRefresh() {
			EventBus.$emit("updateStoreCreditPreview")
		},
		// refreshActivePetData() {
		// 	if (window.innerWidth >= 1200 && window.innerWidth < 1500) {
		// 		this.limitFilter = 9
		// 		this.increment = 9
		// 	}
		// 	this.onLoad = true
		// 	this.getBrandList()
		// 	this.getProductTypeList()
		// 	this.setCartCount(this.getActivePet.id)
		// 	this.setPendingOrderCount(this.getActivePet.id)
		// },
		async refreshActivePetData() {
			if (window.innerWidth >= 1200 && window.innerWidth < 1500) {
				this.limitFilter = 9;
				this.increment = 9;
			}
		
			// Await the necessary functions that return promises
			try {
				await this.getBrandList(); // Ensure it completes before moving on
				await this.getProductTypeList(); // Ensure this completes before moving on
		
				// Assuming setCartCount and setPendingOrderCount are synchronous
				// If they are not, make them awaitable or ensure they finish before proceeding
				this.setCartCount(this.getActivePet.id);
				this.setPendingOrderCount(this.getActivePet.id);
			} catch (error) {
				console.error("Error in refreshing active pet data:", error);
			}
		},
		
		async getProductTypeList() {
			this.isProductTypeLoading = true
			ProductService.getProductTypes().then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.productTypeList = res.data

					// push bundle to product type list
					this.productTypeList.push({ id: 5, name: "Doggy Packs" })

					// set selected type based on route
					this.setSelectedProductType()
				} else {
					this.showGenericErrorToast()
				}
				this.isProductTypeLoading = false
			})
		},
		setSelectedProductType() {
			this.selectedProductType = null;
			this.isPriceFilter = false;
			let isLoadMore = false;
			
			// Check if query parameters exist for product type and set the selected product type
			if (this.$route.query && this.$route.query.type) {
				this.selectedProductType = this.productTypeList.find(
				(type) => type.name === this.$route.query.type
				);
			}
			
			// Set product name and price filter from query params if available
			if (this.$route.query && this.$route.query.productName) {
				this.productName = this.$route.query.productName;
			}
			
			if (this.$route.query && this.$route.query.price) {
				this.selectedPrice = this.priceList.find((type) => type.name === this.$route.query.price);
				this.isPriceFilter = true;
			}
			
			let pageVal = 0;
			// Set page number if it's in the query params
			if (this.$route.query && this.$route.query.page) {
				pageVal= parseInt(this.$route.query.page)
				isLoadMore = true;
				this.increment = pageVal * this.limitFilter
				this.page =  pageVal
			}
			
			// Ensure that after the parameters are set, the product list is fetched
			this.getProductList(isLoadMore, false, this.isPriceFilter);
			this.onLoad = false;
		},

		getProductList(isLoadMore, isFilter, isPriceFilter) {
			this.isAPILoading = true
			this.productAPICall(isLoadMore, isFilter, isPriceFilter)
		},
		loadMore() {
			this.isLoadMoreLoading = true
			this.page++
			this.updateUrlParam('page', this.page);
			this.limitFilter += this.increment
			this.productAPICall(true, false, false)
		},
		productAPICall(isLoadMore, isFilter, isPriceFilter) {
			let queryParams = {
				page: this.page, // Use the current page
				limit: this.increment,
				f_status: "A",
				sortBy: "stockQty",
				desc: true,
			};

			// Append price filter if applicable
			if (this.selectedPrice) {
				queryParams["desc"] = this.selectedPrice.id === "sale" ? true : this.selectedPrice.id;
				queryParams["sortBy"] = "price";
				queryParams["limit"] = isPriceFilter ? this.limitFilter : this.increment;
				queryParams["f_onSale"] = this.selectedPrice.id === "sale" ? true : false;
			} else {
				queryParams["f_onSale"] = false;
			}

			// Append brand filter if applicable
			if (this.selectedBrand) {
				queryParams["f_brandId"] = this.selectedBrand.id;
			}

			// Append product type filter if applicable
			if (this.selectedProductType) {
				if (this.selectedProductType.id === 5) {
				queryParams["f_isCustomBundle"] = "t";
				} else {
				queryParams["f_productTypeId"] = this.selectedProductType.id;
				queryParams["f_isCustomBundle"] = "f";
				}
			}

			// Add search filters
			if (this.productName) {
				queryParams["f_name"] = this.productName;
			}

			// When a filter is selected, reset to the first page
			if (isFilter) {
				queryParams["page"] = 1;
			}

			if(this.increment > this.limitFilter) {
				this.increment = this.limitFilter;
				queryParams["page"] = 1;
			}

			ProductService.getProducts(this.getActivePet.id, queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					if (isLoadMore) {
						this.productList.push(...res.data.data)
					} else {
						this.productList = res.data.data
					}

					this.isAPILoading = false
					this.isLoadMoreLoading = false
					if (res.data.pagination.totalCount && res.data.pagination.totalCount > this.limitFilter) {
						this.showNoResult = false
					} else {
						this.showNoResult = true
					}
				} else {
					this.showAPIErrorToast("Unable to fetch product list.", res)
					this.isAPILoading = false
					this.isLoadMoreLoading = false
				}
			})
		},
		async getBrandList(productTypeName) {
			this.isBrandsLoading = true
			BrandService.getBrands({ productTypeName }).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.brandList = res.data.data
					if (this.$route.query && this.$route.query.brand) {
						this.selectedBrand = this.brandList.find((type) => type.name === this.$route.query.brand)
					} 
		
				} else {
					this.showGenericErrorToast()
				}

				this.isBrandsLoading = false
			})
		},
		showItemModal(list) {
			this.$router.push(`/products/details?sku=${list.id}`)
		},
		checkIfMultipleBrands(bundleProducts) {
			// Remove Null and Duplicate Brands in a single Product List.
			const brands = [...new Set(bundleProducts.map((item) => item.brand.name))]

			return {
				name: brands.length > 1 ? "MULTIPLE BRANDS" : brands[0],
				brands,
				isMultiple: brands.length > 1,
			}
		},
	},
	beforeDestroy() {
		if (this.fn && typeof this.fn === 'function') {
		  this.fn();
		} 
	  }
}
